// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1AlVI","image":"styles-module__image___2mJ6t","title":"styles-module__title___2206M","subtext":"styles-module__subtext___3HZ98"};